import { computed, makeAutoObservable } from 'mobx';
import { CustomSelectionsTemplateModelType } from 'src/api/config/customSelectionsTemplate/getCustomSelectionsTemplateList';
import { isSelectionTemplateField } from '../commonCmsGuard';
import { SingleFieldType } from './CustomSelectionsTemplateState';

export class CustomSelectionItemState {
    constructor(
        private readonly slugInner: string,
        private readonly getSelectionBySlug: (slug: string) => CustomSelectionsTemplateModelType | null
    ) {
        makeAutoObservable(this);
    }

    @computed get selectionRaw(): CustomSelectionsTemplateModelType | null {
        return this.getSelectionBySlug(this.slugInner);
    }

    @computed get id(): number | null {
        return this.selectionRaw?.id ?? null;
    }

    @computed get label(): string {
        return this.selectionRaw?.label ?? '';
    }

    @computed get slug(): string {
        return this.selectionRaw?.slug ?? '';
    }

    @computed get isImage(): boolean {
        return this.selectionRaw?.is_image ?? false;
    }

    @computed get isRating(): boolean {
        return this.selectionRaw?.is_rating ?? false;
    }

    @computed get isDescription(): boolean {
        return this.selectionRaw?.is_description ?? false;
    }

    @computed get isColor(): boolean {
        return this.selectionRaw?.is_color ?? false;
    }

    @computed get fields(): Array<SingleFieldType> {
        if (this.selectionRaw !== null && isSelectionTemplateField(this.selectionRaw.fields)) {
            return this.selectionRaw.fields;
        }
        return [];
    }
}
